import React from 'react';
import { Form, Input, Typography, Space } from 'antd';
import { SCENARIO_THEME } from './scenarioTheme';
import { Trans, useTranslation } from 'react-i18next';
const { Title } = Typography;
const Step1_General = ({ formData, setFormData }) => {
    const { t } = useTranslation();
    const theme = SCENARIO_THEME.general;
    const IconComponent = theme.icon;
    return (React.createElement("div", null,
        React.createElement(Space, { style: { marginBottom: 24 } },
            React.createElement(IconComponent, { style: { fontSize: '20px', color: theme.color } }),
            React.createElement(Title, { level: 4, style: { margin: 0, color: theme.color } }, theme.name)),
        React.createElement(Typography.Paragraph, { style: { marginBottom: 24, color: '#666' } },
            React.createElement(Trans, { i18nKey: "setUpBasicInfo" })),
        React.createElement(Form, { layout: "vertical", initialValues: formData, onValuesChange: (changedValues, allValues) => {
                setFormData(allValues);
            } },
            React.createElement(Form.Item, { label: React.createElement(Trans, { i18nKey: "scenarioName" }), name: "name", rules: [{ required: true, message: React.createElement(Trans, { i18nKey: "pleaseInputScenarioName", defaults: "Please input the scenario name!" }) }] },
                React.createElement(Input, { placeholder: t('scenarioNamePlaceholder', 'Enter a descriptive name for your scenario') })),
            React.createElement(Form.Item, { label: React.createElement(Trans, { i18nKey: "description" }), name: "description" },
                React.createElement(Input.TextArea, { rows: 4, placeholder: t('scenarioDescriptionPlaceholder', 'Describe what this scenario does and when it should be triggered') })))));
};
export default Step1_General;
